import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { IEarnedCommission } from '../../../types/commission';
import { RootState } from '../..';

export interface IGetEarnedCommissionsResponse {
  status?: boolean;
  message?: string;
  data?: {
    transactions?: IEarnedCommission[];
    page: number;
    dataSize: number;
    total: number;
  };
  errors?: IApiResponseError;
}

const initialState: IApiState<IGetEarnedCommissionsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getEarnedCommissionsAsync = createAsyncThunk(
  'earnedCommissions/get',
  async (commissionNumber: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/commission/transactions/${commissionNumber}`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IGetEarnedCommissionsResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const earnedCommissionsFetch = createSlice({
  name: 'earnedCommissions/fetch',
  initialState,
  reducers: {
    resetEarnedCommissions: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEarnedCommissionsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getEarnedCommissionsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetEarnedCommissionsResponse;
      })
      .addCase(getEarnedCommissionsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetEarnedCommissionsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetEarnedCommissions } = earnedCommissionsFetch.actions;
export default earnedCommissionsFetch.reducer;
